import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=517c1159&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=517c1159&prod&lang=css"
import style1 from "./NewMessage.vue?vue&type=style&index=1&id=517c1159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c1159",
  null
  
)

export default component.exports